import * as React from 'react'
import { cn } from '@/lib/utils'

interface ShimmerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
}

const ShimmerButton = React.forwardRef<HTMLButtonElement, ShimmerButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'group relative inline-flex items-center justify-center overflow-hidden rounded-lg px-4 py-2 text-sm font-medium',
          'bg-[linear-gradient(110deg,#191919,45%,#3a3a3a,55%,#191919)] dark:bg-[linear-gradient(110deg,#e3e3e3,45%,#ffffff,55%,#e3e3e3)]',
          'bg-[length:200%_100%] animate-shimmer',
          'text-[#e3e3e3] dark:text-[#191919]',
          'transition-all hover:shadow-md hover:shadow-foreground/20',
          'disabled:pointer-events-none disabled:opacity-50',
          className
        )}
        {...props}
      >
        {children}
      </button>
    )
  }
)
ShimmerButton.displayName = 'ShimmerButton'

export { ShimmerButton }
